exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-page-homecare-pdf[data-v-6f7db29c] {\n  width: 100%;\n  z-index: 9000;\n  position: relative;\n}\n", ""]);

// exports
